import {
    fetchGetCreditCardTellMoneyUserConsent,
    GetCreditCardTellMoneyUserConsentResponse
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { getTellMoneyUserConsentKey } from './queryKeys';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useGetTellMoneyUserConsent = () => {
    const stateKey = useStateKey();

    const { data: userConsents } = useQuery({
        queryKey: getTellMoneyUserConsentKey(stateKey),
        queryFn: async () => {
            const responseData = await fetchGetCreditCardTellMoneyUserConsent({
                stateKey
            });
            return responseData;
        },
        suspense: true,
        select: (response: GetCreditCardTellMoneyUserConsentResponse) =>
            response.consents
    });

    return userConsents ?? [];
};
